var _ellipse, _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _path6, _path7, _circle, _circle2, _circle3, _circle4, _line, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHappy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 123,
    viewBox: "0 0 155 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.5,
    cy: 119.5,
    rx: 23.5,
    ry: 3.5,
    fill: "#D2E7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5514 33.0069C19.3197 33.1463 18.7606 33.264 17.8546 33.5745C14.4942 34.7264 11.8815 37.4762 10.9225 40.8704C10.6762 41.7421 10.5066 42.8661 10.5044 43.6408L10.5036 43.9211L10.38 43.8987C9.98973 43.828 9.28242 43.7904 8.7529 43.8122C7.45236 43.8656 6.31518 44.149 5.15626 44.7083C2.6772 45.9047 0.969352 47.9735 0.280814 50.614C-0.0430357 51.8558 -0.0896204 53.3612 0.155865 54.65C0.815591 58.1138 3.51889 60.8798 7.05924 61.7135C7.5117 61.8201 8.18003 61.9226 8.4225 61.9226C8.51803 61.9226 8.60675 61.9397 8.61969 61.9606C8.6528 62.0142 44.0406 62.0126 44.51 61.959C46.912 61.6846 48.9975 60.2782 50.1537 58.153C50.944 56.7004 51.1959 54.8997 50.8455 53.2086C50.4552 51.3256 49.263 49.6012 47.617 48.5391C47.1861 48.261 46.3862 47.8928 45.8801 47.7397C45.2288 47.5426 44.6585 47.4538 43.8725 47.4269L43.1969 47.4038V47.1663C43.1969 46.8268 43.1286 46.205 43.0401 45.7403C42.5684 43.2605 41.0305 41.0288 38.9032 39.7366C36.9374 38.5425 34.5876 38.1228 32.3499 38.5661C31.9609 38.6431 31.3411 38.8021 31.1481 38.8744C31.1255 38.8828 30.9656 38.6509 30.7927 38.359C30.3001 37.5273 29.8369 36.9369 29.0991 36.2002C28.0623 35.165 27.0851 34.4907 25.8024 33.9253C24.3863 33.3013 23.1269 33.028 21.56 33.0048C21.0785 32.9977 20.6247 32.9986 20.5514 33.0069Z",
    fill: "#EBF7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.551 12.0071C123.32 12.1514 122.761 12.2731 121.855 12.5943C118.494 13.7859 115.882 16.6305 114.923 20.1417C114.676 21.0436 114.507 22.2064 114.504 23.0077L114.504 23.2977L114.38 23.2745C113.99 23.2014 113.282 23.1625 112.753 23.185C111.452 23.2403 110.315 23.5335 109.156 24.112C106.677 25.3497 104.969 27.4898 104.281 30.2214C103.957 31.506 103.91 33.0633 104.156 34.3965C104.816 37.9798 107.519 40.8411 111.059 41.7036C111.512 41.8139 112.18 41.9199 112.423 41.9199C112.518 41.9199 112.607 41.9376 112.62 41.9593C112.653 42.0147 148.041 42.013 148.51 41.9575C150.912 41.6738 152.997 40.2189 154.154 38.0204C154.944 36.5177 155.196 34.6548 154.845 32.9055C154.455 30.9576 153.263 29.1737 151.617 28.0749C151.186 27.7872 150.386 27.4064 149.88 27.248C149.229 27.0441 148.659 26.9522 147.872 26.9244L147.197 26.9005V26.6547C147.197 26.3036 147.129 25.6604 147.04 25.1796C146.568 22.6144 145.031 20.3056 142.903 18.9689C140.937 17.7336 138.588 17.2994 136.35 17.758C135.961 17.8377 135.341 18.0022 135.148 18.0769C135.126 18.0856 134.966 17.8457 134.793 17.5438C134.3 16.6834 133.837 16.0727 133.099 15.3106C132.062 14.2396 131.085 13.5421 129.802 12.9572C128.386 12.3117 127.127 12.0289 125.56 12.0049C125.079 11.9976 124.625 11.9986 124.551 12.0071Z",
    fill: "#EBF7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5787 10.8392C52.319 10.4749 52.1189 10.0588 51.9963 9.60119C51.4461 7.54759 52.6648 5.43674 54.7184 4.88648C56.3578 4.44718 58.0338 5.13533 58.9231 6.47565C59.023 4.87027 60.1304 3.43634 61.7699 2.99704C63.8235 2.44678 65.9343 3.66548 66.4846 5.71908C66.6043 6.16581 66.6403 6.61525 66.6021 7.05074C66.7649 9.34196 63.4502 14.7762 61.4947 15.3002C59.5479 15.8218 53.6549 12.8947 52.5787 10.8392Z",
    fill: "#FF536B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6619 7.83348C96.88 7.64895 97.0704 7.4243 97.2215 7.16269C97.9244 5.94521 97.5072 4.38843 96.2898 3.68552C95.3185 3.12477 94.1313 3.27683 93.334 3.97938C93.5436 2.93768 93.0817 1.83371 92.1105 1.27303C90.893 0.570118 89.3363 0.987257 88.6333 2.20474C88.4761 2.47704 88.3749 2.76632 88.3262 3.05922C87.8722 4.52705 89.2574 8.64394 90.4105 9.30969C91.5722 9.9804 95.6775 8.98389 96.6619 7.83348Z",
    fill: "#FF536B",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3353 15.2236C83.3261 14.9381 83.2684 14.6493 83.1572 14.3685C82.6396 13.0614 81.1605 12.4213 79.8534 12.9388C78.8107 13.3517 78.1924 14.3765 78.2477 15.4378C77.5615 14.6265 76.4095 14.3028 75.3668 14.7156C74.0597 15.2331 73.4197 16.7123 73.9372 18.0194C74.0529 18.3117 74.2168 18.5707 74.4161 18.7908C75.2844 20.0583 79.3712 21.5299 80.6092 21.0397C81.8565 20.5459 83.6254 16.7097 83.3353 15.2236Z",
    fill: "#FF536B",
    fillOpacity: 0.68
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78.8242,
    y: 87.7227,
    width: 13.2759,
    height: 31.8621,
    rx: 5.5,
    fill: "#3C89F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5664,
    y: 87.7227,
    width: 13.2759,
    height: 31.8621,
    rx: 5.5,
    fill: "#3C89F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5664,
    y: 110.293,
    width: 13.2759,
    height: 3.98276,
    fill: "#FF6600"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 78.8242,
    y: 110.293,
    width: 13.2759,
    height: 3.98276,
    fill: "#FF6600"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 23,
    width: 80,
    height: 80,
    rx: 16,
    fill: "#3C89F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3022 97.0362C73.7576 96.8897 70.7851 92.6351 69.2759 89.9956C68.8403 89.2339 69.5803 88.3839 70.4271 88.614C71.951 89.0282 73.9776 89.4727 75.566 89.4406C77.7426 89.3965 81.3407 88.7084 83.4007 88.2771C84.128 88.1248 84.7549 88.7746 84.514 89.4775C83.6089 92.1183 81.3371 97.203 77.3022 97.0362Z",
    fill: "#05157B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.123 94.2939C81.1634 95.7333 79.6391 97.1727 77.325 97.1727C75.0108 97.1727 73.9551 95.902 72.9955 94.9423C72.9955 93.6174 74.9401 92.3746 77.325 92.3746C79.7099 92.3746 82.123 92.9689 82.123 94.2939Z",
    fill: "#EB4E86"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.8854,
    cy: 85.733,
    r: 3.31897,
    fill: "#5AB3E1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.1119,
    cy: 85.733,
    r: 3.31897,
    fill: "#5AB3E1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.198,
    cy: 73.7874,
    r: 5.57414,
    stroke: "#FBFBFB",
    strokeWidth: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.8007,
    cy: 73.7874,
    r: 5.57414,
    stroke: "#FBFBFB",
    strokeWidth: 0.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 74.4012,
    y1: 69.6007,
    x2: 80.6012,
    y2: 69.6007,
    stroke: "#FBFBFB",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8087 74.4532C82.8087 74.4532 83.8068 73.0482 85.0214 73.129C86.1212 73.2021 86.7915 74.4532 86.7915 74.4532",
    stroke: "#05157B",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2061 74.4532C68.2061 74.4532 69.2042 73.0482 70.4187 73.129C71.5185 73.2021 72.1888 74.4532 72.1888 74.4532",
    stroke: "#05157B",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.61e2eaaac05557e7274a34d3ed930149.svg";
export { ForwardRef as ReactComponent };